export default __webpack_public_path__ + "static/media/fvidsdownload.0c766f64.png";